export default __webpack_public_path__ + "static/media/noordzee_thumb.a91a33e8.png";